import { render } from "./_id.vue?vue&type=template&id=fdfe8ee2&ts=true"
import script from "./_id.vue?vue&type=script&lang=ts"
export * from "./_id.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__